import { useTheme } from '@mui/material';

import { getInsetEdgeShadows } from '~/utils/helpers/css';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    root: {
      height: '100%',
      display: 'grid',
      gridTemplateRows: 'auto 1fr',
      gridTemplateAreas: `
        'toolbar'
        'content'
      `,
    },
    toolbar: {
      gridArea: 'toolbar',
      display: 'grid',
      gridTemplateColumns: `auto 1fr auto`,
      gridTemplateRows: '1fr',
      gridTemplateAreas: `"range tabs total"`,
      alignItems: 'end',
      backgroundColor: '#eee',
    },
    datePicker: {
      gridArea: 'range',
      display: 'grid',
      gridTemplateColumns: 'repeat(3, auto)',
      alignItems: 'center',
      padding: theme.spacing(1, 3),
      boxShadow: getInsetEdgeShadows({
        edges: ['bottom'],
      }),
    },
    textField: {
      maxWidth: '120px',
    },
    tabs: {
      gridArea: 'tabs',
    },
    contentSlot: {
      gridArea: 'content',
      width: '100%',
      display: 'grid',
      '& .MuiDataGrid-root': { borderRadius: 0 },
      position: 'relative',
    },
    content: {
      position: 'absolute',
      width: '100%',
      height: '100%',
    },
  };
};
